export default   [
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Bamyan GPO",
      "postal_code": 1601,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Bamyan North",
      "postal_code": 1602,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Bamyan South",
      "postal_code": 1603,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Choni PO Bamyan city",
      "postal_code": 1604,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Kahmard",
      "postal_code": 1656,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Mulah Ghulam Gharb PO bamyan city",
      "postal_code": 1606,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Panjab",
      "postal_code": 1652,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Saighan",
      "postal_code": 1654,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Shash Pule Sharqi PO bamyan city",
      "postal_code": 1605,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Shebar",
      "postal_code": 1655,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Waras",
      "postal_code": 1653,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Yakawlang",
      "postal_code": 1651,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Bamyan",
      "city": "Yakawlang Number 2",
      "postal_code": 1657,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Bamyan GPO",
      "postal_code": 1601,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Bamyan North",
      "postal_code": 1602,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Bamyan South",
      "postal_code": 1603,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Choni PO Bamyan city",
      "postal_code": 1604,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Kahmard",
      "postal_code": 1656,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Mulah Ghulam Gharb PO bamyan city",
      "postal_code": 1606,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Panjab",
      "postal_code": 1652,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Saighan",
      "postal_code": 1654,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Shash Pule Sharqi PO bamyan city",
      "postal_code": 1605,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Shebar",
      "postal_code": 1655,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Waras",
      "postal_code": 1653,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Yakawlang",
      "postal_code": 1651,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Kahmard",
      "city": "Yakawlang Number 2",
      "postal_code": 1657,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Bamyan GPO",
      "postal_code": 1601,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Bamyan North",
      "postal_code": 1602,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Bamyan South",
      "postal_code": 1603,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Choni PO Bamyan city",
      "postal_code": 1604,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Kahmard",
      "postal_code": 1656,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Mulah Ghulam Gharb PO bamyan city",
      "postal_code": 1606,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Panjab",
      "postal_code": 1652,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Saighan",
      "postal_code": 1654,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Shash Pule Sharqi PO bamyan city",
      "postal_code": 1605,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Shebar",
      "postal_code": 1655,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Waras",
      "postal_code": 1653,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Yakawlang",
      "postal_code": 1651,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Panjab",
      "city": "Yakawlang Number 2",
      "postal_code": 1657,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Bamyan GPO",
      "postal_code": 1601,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Bamyan North",
      "postal_code": 1602,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Bamyan South",
      "postal_code": 1603,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Choni PO Bamyan city",
      "postal_code": 1604,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Kahmard",
      "postal_code": 1656,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Mulah Ghulam Gharb PO bamyan city",
      "postal_code": 1606,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Panjab",
      "postal_code": 1652,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Saighan",
      "postal_code": 1654,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Shash Pule Sharqi PO bamyan city",
      "postal_code": 1605,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Shebar",
      "postal_code": 1655,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Waras",
      "postal_code": 1653,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Yakawlang",
      "postal_code": 1651,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Sayghan",
      "city": "Yakawlang Number 2",
      "postal_code": 1657,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Bamyan GPO",
      "postal_code": 1601,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Bamyan North",
      "postal_code": 1602,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Bamyan South",
      "postal_code": 1603,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Choni PO Bamyan city",
      "postal_code": 1604,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Kahmard",
      "postal_code": 1656,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Mulah Ghulam Gharb PO bamyan city",
      "postal_code": 1606,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Panjab",
      "postal_code": 1652,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Saighan",
      "postal_code": 1654,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Shash Pule Sharqi PO bamyan city",
      "postal_code": 1605,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Shebar",
      "postal_code": 1655,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Waras",
      "postal_code": 1653,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Yakawlang",
      "postal_code": 1651,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Shibar",
      "city": "Yakawlang Number 2",
      "postal_code": 1657,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Bamyan GPO",
      "postal_code": 1601,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Bamyan North",
      "postal_code": 1602,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Bamyan South",
      "postal_code": 1603,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Choni PO Bamyan city",
      "postal_code": 1604,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Kahmard",
      "postal_code": 1656,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Mulah Ghulam Gharb PO bamyan city",
      "postal_code": 1606,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Panjab",
      "postal_code": 1652,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Saighan",
      "postal_code": 1654,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Shash Pule Sharqi PO bamyan city",
      "postal_code": 1605,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Shebar",
      "postal_code": 1655,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Waras",
      "postal_code": 1653,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Yakawlang",
      "postal_code": 1651,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Waras",
      "city": "Yakawlang Number 2",
      "postal_code": 1657,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Bamyan GPO",
      "postal_code": 1601,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Bamyan North",
      "postal_code": 1602,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Bamyan South",
      "postal_code": 1603,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Choni PO Bamyan city",
      "postal_code": 1604,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Kahmard",
      "postal_code": 1656,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Mulah Ghulam Gharb PO bamyan city",
      "postal_code": 1606,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Panjab",
      "postal_code": 1652,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Saighan",
      "postal_code": 1654,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Shash Pule Sharqi PO bamyan city",
      "postal_code": 1605,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Shebar",
      "postal_code": 1655,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Waras",
      "postal_code": 1653,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Yakawlang",
      "postal_code": 1651,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang",
      "city": "Yakawlang Number 2",
      "postal_code": 1657,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Bamyan GPO",
      "postal_code": 1601,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Bamyan North",
      "postal_code": 1602,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Bamyan South",
      "postal_code": 1603,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Choni PO Bamyan city",
      "postal_code": 1604,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Kahmard",
      "postal_code": 1656,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Mulah Ghulam Gharb PO bamyan city",
      "postal_code": 1606,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Panjab",
      "postal_code": 1652,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Saighan",
      "postal_code": 1654,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Shash Pule Sharqi PO bamyan city",
      "postal_code": 1605,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Shebar",
      "postal_code": 1655,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Waras",
      "postal_code": 1653,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Yakawlang",
      "postal_code": 1651,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Bamyan",
      "district": "Yakawlang 2",
      "city": "Yakawlang Number 2",
      "postal_code": 1657,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 16
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Bato",
      "postal_code": 4259,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Giti",
      "postal_code": 4258,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Gizab",
      "postal_code": 4252,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Ishterlai",
      "postal_code": 4255,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Kejran",
      "postal_code": 4251,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Khedir",
      "postal_code": 4257,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Mir Amor",
      "postal_code": 4254,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Nili GPO",
      "postal_code": 4201,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Nili North",
      "postal_code": 4202,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Nili South",
      "postal_code": 4203,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Sang-i-Takht",
      "postal_code": 4256,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Ishtarlay",
      "city": "Shahristan",
      "postal_code": 4253,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Bato",
      "postal_code": 4259,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Giti",
      "postal_code": 4258,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Gizab",
      "postal_code": 4252,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Ishterlai",
      "postal_code": 4255,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Kejran",
      "postal_code": 4251,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Khedir",
      "postal_code": 4257,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Mir Amor",
      "postal_code": 4254,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Nili GPO",
      "postal_code": 4201,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Nili North",
      "postal_code": 4202,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Nili South",
      "postal_code": 4203,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Sang-i-Takht",
      "postal_code": 4256,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Khedir",
      "city": "Shahristan",
      "postal_code": 4253,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Bato",
      "postal_code": 4259,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Giti",
      "postal_code": 4258,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Gizab",
      "postal_code": 4252,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Ishterlai",
      "postal_code": 4255,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Kejran",
      "postal_code": 4251,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Khedir",
      "postal_code": 4257,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Mir Amor",
      "postal_code": 4254,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Nili GPO",
      "postal_code": 4201,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Nili North",
      "postal_code": 4202,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Nili South",
      "postal_code": 4203,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Sang-i-Takht",
      "postal_code": 4256,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kijran",
      "city": "Shahristan",
      "postal_code": 4253,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Bato",
      "postal_code": 4259,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Giti",
      "postal_code": 4258,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Gizab",
      "postal_code": 4252,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Ishterlai",
      "postal_code": 4255,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Kejran",
      "postal_code": 4251,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Khedir",
      "postal_code": 4257,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Mir Amor",
      "postal_code": 4254,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Nili GPO",
      "postal_code": 4201,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Nili North",
      "postal_code": 4202,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Nili South",
      "postal_code": 4203,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Sang-i-Takht",
      "postal_code": 4256,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Kitti",
      "city": "Shahristan",
      "postal_code": 4253,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Bato",
      "postal_code": 4259,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Giti",
      "postal_code": 4258,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Gizab",
      "postal_code": 4252,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Ishterlai",
      "postal_code": 4255,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Kejran",
      "postal_code": 4251,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Khedir",
      "postal_code": 4257,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Mir Amor",
      "postal_code": 4254,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Nili GPO",
      "postal_code": 4201,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Nili North",
      "postal_code": 4202,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Nili South",
      "postal_code": 4203,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Sang-i-Takht",
      "postal_code": 4256,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Miramor",
      "city": "Shahristan",
      "postal_code": 4253,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Bato",
      "postal_code": 4259,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Giti",
      "postal_code": 4258,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Gizab",
      "postal_code": 4252,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Ishterlai",
      "postal_code": 4255,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Kejran",
      "postal_code": 4251,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Khedir",
      "postal_code": 4257,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Mir Amor",
      "postal_code": 4254,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Nili GPO",
      "postal_code": 4201,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Nili North",
      "postal_code": 4202,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Nili South",
      "postal_code": 4203,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Sang-i-Takht",
      "postal_code": 4256,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Nili",
      "city": "Shahristan",
      "postal_code": 4253,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Bato",
      "postal_code": 4259,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Giti",
      "postal_code": 4258,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Gizab",
      "postal_code": 4252,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Ishterlai",
      "postal_code": 4255,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Kejran",
      "postal_code": 4251,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Khedir",
      "postal_code": 4257,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Mir Amor",
      "postal_code": 4254,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Nili GPO",
      "postal_code": 4201,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Nili North",
      "postal_code": 4202,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Nili South",
      "postal_code": 4203,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Sang-i-Takht",
      "postal_code": 4256,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Sangi Takht",
      "city": "Shahristan",
      "postal_code": 4253,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Bato",
      "postal_code": 4259,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Giti",
      "postal_code": 4258,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Gizab",
      "postal_code": 4252,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Ishterlai",
      "postal_code": 4255,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Kejran",
      "postal_code": 4251,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Khedir",
      "postal_code": 4257,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Mir Amor",
      "postal_code": 4254,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Nili GPO",
      "postal_code": 4201,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Nili North",
      "postal_code": 4202,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Nili South",
      "postal_code": 4203,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Sang-i-Takht",
      "postal_code": 4256,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Bamyan",
      "province": "Daykundi",
      "district": "Shahristan",
      "city": "Shahristan",
      "postal_code": 4253,
      "region_abbr": "BMN",
      "region_no": "RGN 001",
      "region_code": "BMN - RGN 001",
      "provincial_code": 42
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Anar Dara",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bakwa",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Bala Buluk",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Farah",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Gulistan",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Khaki Safed",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Lash Wa Juwayn",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pur Chaman",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht-e-Koh",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Pusht Rod",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Qala-I-Kah/",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Anar Dara",
      "postal_code": 3154,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Bakwa",
      "postal_code": 3157,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Bala Buluk",
      "postal_code": 3158,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Farah GPO",
      "postal_code": 3101,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Farah North",
      "postal_code": 3102,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Farah South",
      "postal_code": 3103,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Gulistan",
      "postal_code": 3159,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Khak-i-Safed",
      "postal_code": 3155,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Lash-i-Juwayn",
      "postal_code": 3151,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Posht koh Qala-i-Kah",
      "postal_code": 3153,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Pur chaman",
      "postal_code": 3160,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Pushtrud",
      "postal_code": 3156,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Farah",
      "province": "Farah",
      "district": "Shib Koh",
      "city": "Shibkoh Qala-i-Kah",
      "postal_code": 3152,
      "region_abbr": "FRH",
      "region_no": "RGN 003",
      "region_code": "FRH- RGN 003",
      "provincial_code": 31
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ab Band",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ajristan",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Andar",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Deh Yak",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Gelan",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Ghazni",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Giro",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghatū",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Jaghori",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khogyani",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Khwaja Umari",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Malistan",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Muqur",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawa",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Nawur",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Qarabagh",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Rashidan",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Waghaz",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Ab Band",
      "postal_code": 2354,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Ajristan",
      "postal_code": 2367,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Andar",
      "postal_code": 2357,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Deh Yak",
      "postal_code": 2358,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Gelan",
      "postal_code": 2352,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Ghazni GPO",
      "postal_code": 2301,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Ghazni North",
      "postal_code": 2302,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Ghazni South",
      "postal_code": 2303,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Giro",
      "postal_code": 2355,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Jaghatu",
      "postal_code": 2362,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Jaghuri",
      "postal_code": 2366,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Khwaja Omari",
      "postal_code": 2360,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Malistan",
      "postal_code": 2368,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Muqur",
      "postal_code": 2353,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Nawa",
      "postal_code": 2351,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Nawur",
      "postal_code": 2365,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Qara Bagh",
      "postal_code": 2356,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Rashidan",
      "postal_code": 2364,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Waghaz",
      "postal_code": 2363,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Wali M\" Shahid (Khugyani)",
      "postal_code": 2361,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Ghazni",
      "district": "Zana Khan",
      "city": "Zana Khan",
      "postal_code": 2359,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 23
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmad Aba",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Ahmadkhel",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Chamkani",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Dand Aw Patan",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gardez",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Gerda Serai",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Janikhel District",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Laja Mangal District",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Mirzaka",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Rohani Baba",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Said Karam",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Shwak",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zadran",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zazi (Jaji)",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Ahmad aba",
      "postal_code": 2255,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Dand Patan",
      "postal_code": 2259,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Gardez GPO",
      "postal_code": 2201,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Gardez North",
      "postal_code": 2202,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Gardez South",
      "postal_code": 2203,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Gurdasira",
      "postal_code": 2263,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Jaji",
      "postal_code": 2257,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Jani khel",
      "postal_code": 2260,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Laja Ahmad khel",
      "postal_code": 2256,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Laja Magal",
      "postal_code": 2253,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Mirzaka",
      "postal_code": 2262,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Rohani Baba",
      "postal_code": 2264,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Samkanai",
      "postal_code": 2258,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Sayyid Karam",
      "postal_code": 2254,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Shwak",
      "postal_code": 2252,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Wuza Zadran",
      "postal_code": 2261,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktia",
      "district": "Zurmat",
      "city": "Zurmat",
      "postal_code": 2251,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 22
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Barmal",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Dila",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gayan",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Gomal",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Janikhel",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Khairkot (Zarghun Shar or Katawaz)",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Mata Khan",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Nika",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Omna",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sar Hawza",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Sharana",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Surobi",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Terwa",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Urgun",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wazakhwa",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Wor Mamay",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yahyakhel",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Yusufkhel",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Back khil",
      "postal_code": 2470,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Barmal",
      "postal_code": 2467,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Dila Wa Khushamand",
      "postal_code": 2453,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Giyan",
      "postal_code": 2465,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Gomal",
      "postal_code": 2455,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Jani Khel",
      "postal_code": 2456,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Mata Khan",
      "postal_code": 2459,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Nemat Abad",
      "postal_code": 2472,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Nika",
      "postal_code": 2462,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Omna",
      "postal_code": 2452,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Sar Rawza",
      "postal_code": 2461,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Shakhil Abad",
      "postal_code": 2469,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Sharan GPO",
      "postal_code": 2401,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Sharan North",
      "postal_code": 2402,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Sharan South",
      "postal_code": 2403,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Shegen",
      "postal_code": 2471,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Surubi",
      "postal_code": 2466,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Turwo",
      "postal_code": 2451,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Urgoon",
      "postal_code": 2464,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Wazakhwah",
      "postal_code": 2454,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Wormamay",
      "postal_code": 2468,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Yahya Khel",
      "postal_code": 2458,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Yousuf Khel",
      "postal_code": 2460,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Zarghun Shar",
      "postal_code": 2457,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Ghazni",
      "province": "Paktika",
      "district": "Zerok",
      "city": "Ziruk",
      "postal_code": 2463,
      "region_abbr": "GZNI",
      "region_no": "RGN 004",
      "region_code": "GZNI - RGN 004",
      "provincial_code": 24
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ab Kamari",
      "city": "Ab Kamari",
      "postal_code": 3351,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ab Kamari",
      "city": "Ghormach",
      "postal_code": 3353,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ab Kamari",
      "city": "Jawand",
      "postal_code": 3354,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ab Kamari",
      "city": "Muqur",
      "postal_code": 3356,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ab Kamari",
      "city": "Murghab (Bala Murghab)",
      "postal_code": 3352,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ab Kamari",
      "city": "Qadis",
      "postal_code": 3355,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ab Kamari",
      "city": "Qala-i-Naw GPO",
      "postal_code": 3301,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ab Kamari",
      "city": "Qala-i-Naw North",
      "postal_code": 3302,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ab Kamari",
      "city": "Qala-i-Naw South",
      "postal_code": 3303,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Bala Murghab",
      "city": "Ab Kamari",
      "postal_code": 3351,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Bala Murghab",
      "city": "Ghormach",
      "postal_code": 3353,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Bala Murghab",
      "city": "Jawand",
      "postal_code": 3354,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Bala Murghab",
      "city": "Muqur",
      "postal_code": 3356,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Bala Murghab",
      "city": "Murghab (Bala Murghab)",
      "postal_code": 3352,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Bala Murghab",
      "city": "Qadis",
      "postal_code": 3355,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Bala Murghab",
      "city": "Qala-i-Naw GPO",
      "postal_code": 3301,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Bala Murghab",
      "city": "Qala-i-Naw North",
      "postal_code": 3302,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Bala Murghab",
      "city": "Qala-i-Naw South",
      "postal_code": 3303,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ghormach",
      "city": "Ab Kamari",
      "postal_code": 3351,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ghormach",
      "city": "Ghormach",
      "postal_code": 3353,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ghormach",
      "city": "Jawand",
      "postal_code": 3354,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ghormach",
      "city": "Muqur",
      "postal_code": 3356,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ghormach",
      "city": "Murghab (Bala Murghab)",
      "postal_code": 3352,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ghormach",
      "city": "Qadis",
      "postal_code": 3355,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ghormach",
      "city": "Qala-i-Naw GPO",
      "postal_code": 3301,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ghormach",
      "city": "Qala-i-Naw North",
      "postal_code": 3302,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Ghormach",
      "city": "Qala-i-Naw South",
      "postal_code": 3303,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Jawand",
      "city": "Ab Kamari",
      "postal_code": 3351,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Jawand",
      "city": "Ghormach",
      "postal_code": 3353,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Jawand",
      "city": "Jawand",
      "postal_code": 3354,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Jawand",
      "city": "Muqur",
      "postal_code": 3356,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Jawand",
      "city": "Murghab (Bala Murghab)",
      "postal_code": 3352,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Jawand",
      "city": "Qadis",
      "postal_code": 3355,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Jawand",
      "city": "Qala-i-Naw GPO",
      "postal_code": 3301,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Jawand",
      "city": "Qala-i-Naw North",
      "postal_code": 3302,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Jawand",
      "city": "Qala-i-Naw South",
      "postal_code": 3303,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Muqur",
      "city": "Ab Kamari",
      "postal_code": 3351,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Muqur",
      "city": "Ghormach",
      "postal_code": 3353,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Muqur",
      "city": "Jawand",
      "postal_code": 3354,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Muqur",
      "city": "Muqur",
      "postal_code": 3356,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Muqur",
      "city": "Murghab (Bala Murghab)",
      "postal_code": 3352,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Muqur",
      "city": "Qadis",
      "postal_code": 3355,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Muqur",
      "city": "Qala-i-Naw GPO",
      "postal_code": 3301,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Muqur",
      "city": "Qala-i-Naw North",
      "postal_code": 3302,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Muqur",
      "city": "Qala-i-Naw South",
      "postal_code": 3303,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qadis",
      "city": "Ab Kamari",
      "postal_code": 3351,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qadis",
      "city": "Ghormach",
      "postal_code": 3353,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qadis",
      "city": "Jawand",
      "postal_code": 3354,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qadis",
      "city": "Muqur",
      "postal_code": 3356,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qadis",
      "city": "Murghab (Bala Murghab)",
      "postal_code": 3352,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qadis",
      "city": "Qadis",
      "postal_code": 3355,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qadis",
      "city": "Qala-i-Naw GPO",
      "postal_code": 3301,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qadis",
      "city": "Qala-i-Naw North",
      "postal_code": 3302,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qadis",
      "city": "Qala-i-Naw South",
      "postal_code": 3303,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qala i Naw",
      "city": "Ab Kamari",
      "postal_code": 3351,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qala i Naw",
      "city": "Ghormach",
      "postal_code": 3353,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qala i Naw",
      "city": "Jawand",
      "postal_code": 3354,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qala i Naw",
      "city": "Muqur",
      "postal_code": 3356,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qala i Naw",
      "city": "Murghab (Bala Murghab)",
      "postal_code": 3352,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qala i Naw",
      "city": "Qadis",
      "postal_code": 3355,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qala i Naw",
      "city": "Qala-i-Naw GPO",
      "postal_code": 3301,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qala i Naw",
      "city": "Qala-i-Naw North",
      "postal_code": 3302,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Badghis",
      "district": "Qala i Naw",
      "city": "Qala-i-Naw South",
      "postal_code": 3303,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 33
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Chaghcharan",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Charsada",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Dawlat Yar",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Du Layna",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Lal wa Sarjangal",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Marghab",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Pasaband",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Saghar",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Shahrak",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Taywara",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Char Sada",
      "postal_code": 3257,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Chighcheran GPO",
      "postal_code": 3201,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Chighcheran North",
      "postal_code": 3202,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Chighcheran South",
      "postal_code": 3203,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Dawlatyar",
      "postal_code": 3255,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Duleena",
      "postal_code": 3254,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Lal Wa SarJangal",
      "postal_code": 3256,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Murghab",
      "postal_code": 3260,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Pasaband",
      "postal_code": 3253,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Saghar",
      "postal_code": 3251,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Shahrak",
      "postal_code": 3258,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Taywara",
      "postal_code": 3252,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Ghor",
      "district": "Tulak",
      "city": "Tulak",
      "postal_code": 3259,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 32
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Adraskan",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Chishti Sharif",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Farsi",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Ghoryan",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Gulran",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Guzara",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Herat",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Injil/Enjil",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Karukh",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kohsan",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushk",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Kushki Kuhna",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Obe",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Pashtun Zarghun",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Shindand",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Adraskan",
      "postal_code": 3062,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Bandare Islam Qalah",
      "postal_code": 3041,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Bandare Marzi Torghondi",
      "postal_code": 3042,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Chishti Sharif",
      "postal_code": 3059,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Fersi",
      "postal_code": 3060,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Ghoryan",
      "postal_code": 3051,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Gulran",
      "postal_code": 3053,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Guzara",
      "postal_code": 3065,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Herat East",
      "postal_code": 3004,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Herat GPO",
      "postal_code": 3001,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Herat North",
      "postal_code": 3002,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Herat South",
      "postal_code": 3003,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Herat West",
      "postal_code": 3005,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Injil",
      "postal_code": 3061,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Karrukh",
      "postal_code": 3057,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Kohsan",
      "postal_code": 3052,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Kushk-i-Kuhna",
      "postal_code": 3055,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Kushk (Rubat-i-Sangi)",
      "postal_code": 3054,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Kuwa Zor",
      "postal_code": 3069,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Obe",
      "postal_code": 3058,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Pashtun Zarghun",
      "postal_code": 3056,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Poshte Koh",
      "postal_code": 3067,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Shindand",
      "postal_code": 3063,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Zawel",
      "postal_code": 3068,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Zendahjan",
      "postal_code": 3064,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Herat",
      "province": "Herat",
      "district": "Zinda Jan",
      "city": "Zere Koh",
      "postal_code": 3066,
      "region_abbr": "HRT",
      "region_no": "RGN 005",
      "region_code": "HRT - RGN 005",
      "provincial_code": 30
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Bagrami",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Chahar Asyab",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Deh Sabz",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Farza",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Guldara",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Istalif",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kabul (city)",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Kalakan",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Khaki Jabbar",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mir Bacha Kot",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Mussahi",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Paghman",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Qarabagh",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Shakardara",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Ahmad Shah baba Mina",
      "postal_code": 1012,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Bagrami",
      "postal_code": 1053,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Barikot",
      "postal_code": 1009,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Central Post Office",
      "postal_code": 1001,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Chahar Asyab",
      "postal_code": 1051,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Darul Aman",
      "postal_code": 1004,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Dasht barchi Post office",
      "postal_code": 1016,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Dehburi",
      "postal_code": 1006,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Deh Sabz",
      "postal_code": 1054,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Estalef",
      "postal_code": 1058,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Farza",
      "postal_code": 1059,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Gul Dara",
      "postal_code": 1060,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Kalakan",
      "postal_code": 1062,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Karte Char Post office",
      "postal_code": 1015,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Karte Parwan",
      "postal_code": 1011,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Khairkhana",
      "postal_code": 1008,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Khaki-e-Jabar",
      "postal_code": 1055,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "khoshal khan",
      "postal_code": 1010,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Macrorayan",
      "postal_code": 1002,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Mir Bacha Kot",
      "postal_code": 1063,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Musahi",
      "postal_code": 1052,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Paghman",
      "postal_code": 1064,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Park Hai Sanaty",
      "postal_code": 1013,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Pashtoonistan Post office",
      "postal_code": 1014,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Qara Bagh",
      "postal_code": 1057,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Sayed Noor Mohammad Shah Mina",
      "postal_code": 1005,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Shahr-e-Naw",
      "postal_code": 1003,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Shakar Dara",
      "postal_code": 1061,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Surubi",
      "postal_code": 1056,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Kabul",
      "district": "Surobi",
      "city": "Taimani",
      "postal_code": 1007,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 10
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Azra",
      "city": "Azra",
      "postal_code": 1452,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Azra",
      "city": "Baraki Barak",
      "postal_code": 1454,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Azra",
      "city": "Charkh",
      "postal_code": 1455,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Azra",
      "city": "Kharwar",
      "postal_code": 1456,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Azra",
      "city": "Khushi",
      "postal_code": 1453,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Azra",
      "city": "Mohammad Agha",
      "postal_code": 1451,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Azra",
      "city": "Pul-i-Alam GPO",
      "postal_code": 1401,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Azra",
      "city": "Pul-i-Alam North",
      "postal_code": 1402,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Azra",
      "city": "Pul-i-Alam South",
      "postal_code": 1403,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Baraki Barak",
      "city": "Azra",
      "postal_code": 1452,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Baraki Barak",
      "city": "Baraki Barak",
      "postal_code": 1454,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Baraki Barak",
      "city": "Charkh",
      "postal_code": 1455,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Baraki Barak",
      "city": "Kharwar",
      "postal_code": 1456,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Baraki Barak",
      "city": "Khushi",
      "postal_code": 1453,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Baraki Barak",
      "city": "Mohammad Agha",
      "postal_code": 1451,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Baraki Barak",
      "city": "Pul-i-Alam GPO",
      "postal_code": 1401,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Baraki Barak",
      "city": "Pul-i-Alam North",
      "postal_code": 1402,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Baraki Barak",
      "city": "Pul-i-Alam South",
      "postal_code": 1403,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Charkh",
      "city": "Azra",
      "postal_code": 1452,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Charkh",
      "city": "Baraki Barak",
      "postal_code": 1454,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Charkh",
      "city": "Charkh",
      "postal_code": 1455,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Charkh",
      "city": "Kharwar",
      "postal_code": 1456,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Charkh",
      "city": "Khushi",
      "postal_code": 1453,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Charkh",
      "city": "Mohammad Agha",
      "postal_code": 1451,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Charkh",
      "city": "Pul-i-Alam GPO",
      "postal_code": 1401,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Charkh",
      "city": "Pul-i-Alam North",
      "postal_code": 1402,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Charkh",
      "city": "Pul-i-Alam South",
      "postal_code": 1403,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Kharwar",
      "city": "Azra",
      "postal_code": 1452,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Kharwar",
      "city": "Baraki Barak",
      "postal_code": 1454,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Kharwar",
      "city": "Charkh",
      "postal_code": 1455,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Kharwar",
      "city": "Kharwar",
      "postal_code": 1456,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Kharwar",
      "city": "Khushi",
      "postal_code": 1453,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Kharwar",
      "city": "Mohammad Agha",
      "postal_code": 1451,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Kharwar",
      "city": "Pul-i-Alam GPO",
      "postal_code": 1401,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Kharwar",
      "city": "Pul-i-Alam North",
      "postal_code": 1402,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Kharwar",
      "city": "Pul-i-Alam South",
      "postal_code": 1403,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Khoshi",
      "city": "Azra",
      "postal_code": 1452,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Khoshi",
      "city": "Baraki Barak",
      "postal_code": 1454,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Khoshi",
      "city": "Charkh",
      "postal_code": 1455,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Khoshi",
      "city": "Kharwar",
      "postal_code": 1456,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Khoshi",
      "city": "Khushi",
      "postal_code": 1453,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Khoshi",
      "city": "Mohammad Agha",
      "postal_code": 1451,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Khoshi",
      "city": "Pul-i-Alam GPO",
      "postal_code": 1401,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Khoshi",
      "city": "Pul-i-Alam North",
      "postal_code": 1402,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Khoshi",
      "city": "Pul-i-Alam South",
      "postal_code": 1403,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Logar",
      "city": "Azra",
      "postal_code": 1452,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Logar",
      "city": "Baraki Barak",
      "postal_code": 1454,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Logar",
      "city": "Charkh",
      "postal_code": 1455,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Logar",
      "city": "Kharwar",
      "postal_code": 1456,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Logar",
      "city": "Khushi",
      "postal_code": 1453,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Logar",
      "city": "Mohammad Agha",
      "postal_code": 1451,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Logar",
      "city": "Pul-i-Alam GPO",
      "postal_code": 1401,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Logar",
      "city": "Pul-i-Alam North",
      "postal_code": 1402,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Logar",
      "city": "Pul-i-Alam South",
      "postal_code": 1403,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Mohammad Agha",
      "city": "Azra",
      "postal_code": 1452,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Mohammad Agha",
      "city": "Baraki Barak",
      "postal_code": 1454,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Mohammad Agha",
      "city": "Charkh",
      "postal_code": 1455,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Mohammad Agha",
      "city": "Kharwar",
      "postal_code": 1456,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Mohammad Agha",
      "city": "Khushi",
      "postal_code": 1453,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Mohammad Agha",
      "city": "Mohammad Agha",
      "postal_code": 1451,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Mohammad Agha",
      "city": "Pul-i-Alam GPO",
      "postal_code": 1401,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Mohammad Agha",
      "city": "Pul-i-Alam North",
      "postal_code": 1402,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Mohammad Agha",
      "city": "Pul-i-Alam South",
      "postal_code": 1403,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Puli Alam",
      "city": "Azra",
      "postal_code": 1452,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Puli Alam",
      "city": "Baraki Barak",
      "postal_code": 1454,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Puli Alam",
      "city": "Charkh",
      "postal_code": 1455,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Puli Alam",
      "city": "Kharwar",
      "postal_code": 1456,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Puli Alam",
      "city": "Khushi",
      "postal_code": 1453,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Puli Alam",
      "city": "Mohammad Agha",
      "postal_code": 1451,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Puli Alam",
      "city": "Pul-i-Alam GPO",
      "postal_code": 1401,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Puli Alam",
      "city": "Pul-i-Alam North",
      "postal_code": 1402,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Logar",
      "district": "Puli Alam",
      "city": "Pul-i-Alam South",
      "postal_code": 1403,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 14
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Chaki Wardak",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Day Mirdad",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Hisa-I-Awali Bihsud",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jaghatu",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Jalrez",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Maidan Shar",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Markazi Bihsud",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Nirkh",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Saydabad",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Chak-i-Wardak",
      "postal_code": 1356,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Daimir Dad",
      "postal_code": 1358,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Hissa-i-Awali Behsud",
      "postal_code": 1352,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Jaghatu",
      "postal_code": 1357,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Jalrez",
      "postal_code": 1353,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Maidan Shahr GPO",
      "postal_code": 1301,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Maidan Shahr North",
      "postal_code": 1302,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Maidan Shahr South",
      "postal_code": 1303,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Markaz-i-Behsud",
      "postal_code": 1351,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Nerkh",
      "postal_code": 1354,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kabul",
      "province": "Wardak",
      "district": "Wardak",
      "city": "Sayyid Abad",
      "postal_code": 1355,
      "region_abbr": "KBL",
      "region_no": "RGN 006",
      "region_code": "KBL - RGN 006",
      "provincial_code": 13
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Baghran",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Dishu",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Garmsir",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Grishk (Nahri Saraj)",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Kajaki",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Khanashin (Reg)",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Lashkargah",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Marjah",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Musa Qala",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nad Ali",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawa-I-Barakzayi",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Nawzad",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Sangin",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Baghran",
      "postal_code": 3958,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Dishu",
      "postal_code": 3951,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Garm Ser",
      "postal_code": 3953,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Kajaki",
      "postal_code": 3957,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Lashkargah GPO",
      "postal_code": 3901,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "LashkargahNorth",
      "postal_code": 3902,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Lashkargah South",
      "postal_code": 3903,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Marja",
      "postal_code": 3963,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Musa Qala",
      "postal_code": 3959,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Nad Ali",
      "postal_code": 3961,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Nahr-i-Saraj",
      "postal_code": 3955,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Nawa-i-Barikzayi",
      "postal_code": 3954,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Nawa Mish",
      "postal_code": 3964,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Nawzad",
      "postal_code": 3960,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Reg-i-Khan Nishin",
      "postal_code": 3952,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Sangin",
      "postal_code": 3956,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Helmand",
      "district": "Washir",
      "city": "Washer",
      "postal_code": 3962,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 39
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghandab",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Arghistan",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Daman",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Dand",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Ghorak",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Kandahar",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Khakrez",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maiwand",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Maruf",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Miyanishin",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Nesh",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Panjwayi",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Reg",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shah Wali Kot",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Shorabak",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Spin Boldak",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Takhta-pul",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Arghandab",
      "postal_code": 3860,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Arghistan",
      "postal_code": 3854,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Daman",
      "postal_code": 3856,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Dande",
      "postal_code": 3866,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Ghorak",
      "postal_code": 3865,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Kandahar GPO",
      "postal_code": 3801,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Kandahar North",
      "postal_code": 3802,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Kandahar South",
      "postal_code": 3803,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Khakrez",
      "postal_code": 3859,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Maiwand",
      "postal_code": 3862,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Maruf",
      "postal_code": 3855,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Miyanishin",
      "postal_code": 3864,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Nesh",
      "postal_code": 3858,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Panjwayee",
      "postal_code": 3863,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Reg",
      "postal_code": 3851,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Shah Wali Kot",
      "postal_code": 3857,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Shorabak",
      "postal_code": 3852,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Spin Boldak",
      "postal_code": 3853,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Takhta Pul",
      "postal_code": 3867,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Kandahar",
      "district": "Zhari",
      "city": "Zhire",
      "postal_code": 3861,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 38
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Arghandab",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Atghar",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Daychopan",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Kakar",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Mezana",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Naw Bahar",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Qalat",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shah Joy",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shamulzayi",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Shinkay",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Argahandab",
      "postal_code": 4055,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Atghar",
      "postal_code": 4060,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Daichopan",
      "postal_code": 4054,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Kakar (khak afghan)",
      "postal_code": 4053,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Mizan",
      "postal_code": 4052,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Naw Bahar",
      "postal_code": 4059,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Qalat GPO",
      "postal_code": 4001,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Qalat North",
      "postal_code": 4002,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Qalat South",
      "postal_code": 4003,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Shah joy",
      "postal_code": 4056,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Shemel Zayi",
      "postal_code": 4057,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Shinkai",
      "postal_code": 4058,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Kandahar",
      "province": "Zabul",
      "district": "Tarnak Aw Jaldak",
      "city": "Tarang Wa Jaldak(shahr-e-safa)",
      "postal_code": 4051,
      "region_abbr": "KNDR",
      "region_no": "RGN 008",
      "region_code": "KNDR - RGN 008",
      "provincial_code": 40
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Khost",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Mandozayi",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Musa Khel",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Nadir Shah Kot",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Qalandar",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Sabari",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Shamal",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Spera",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tani",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Baak",
      "postal_code": 2558,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "City post office",
      "postal_code": 2504,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Gurbus",
      "postal_code": 2556,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Jaji Maidan",
      "postal_code": 2560,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Khost GPO",
      "postal_code": 2501,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Khost North",
      "postal_code": 2502,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Khost South",
      "postal_code": 2503,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Manduzay (Esmayel Khil)",
      "postal_code": 2555,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Musa Khel",
      "postal_code": 2561,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Nadir Shah Kot",
      "postal_code": 2554,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Qalandar",
      "postal_code": 2562,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Sabari (Yaqubi)",
      "postal_code": 2559,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Shamul",
      "postal_code": 2553,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Spera",
      "postal_code": 2551,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Tanay",
      "postal_code": 2552,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Khost",
      "province": "Khost",
      "district": "Tirazayi",
      "city": "Tirzayee (Ali Sher)",
      "postal_code": 2557,
      "region_abbr": "KHST",
      "region_no": "RGN 007",
      "region_code": "KHST - RGN 007",
      "provincial_code": 25
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Arghanj Khwa",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Argo",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Baharak",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Darayim",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Fayzabad",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Ishkashim",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Jurm",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Keran wa Menjan",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khash",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Khwahan",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kishim",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kohistan",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Kuf Ab",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Maimay (Darwaz-e Payin)",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Nusay (Darwaz-e Bala)",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Raghistan",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shahri Buzurg",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Sheghnan",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shekay",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Shuhada",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tagab",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Tishkan",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Wakhan",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Warduj",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yaftali Sufla",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yamgan",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Yawan",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Arghanj Khwah",
      "postal_code": 3468,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Argo",
      "postal_code": 3457,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Baharak",
      "postal_code": 3470,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Darayim",
      "postal_code": 3456,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Eshkashim",
      "postal_code": 3473,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Faiz Abad GPO",
      "postal_code": 3401,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Faiz Abad North",
      "postal_code": 3402,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Faiz Abad South",
      "postal_code": 3403,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Jurm",
      "postal_code": 3471,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Khash",
      "postal_code": 3462,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Kiran Wa Menjan",
      "postal_code": 3451,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "kishm",
      "postal_code": 3454,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Kohistan",
      "postal_code": 3460,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Kufab",
      "postal_code": 3463,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Maimi",
      "postal_code": 3465,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Nesay",
      "postal_code": 3466,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Raghistan",
      "postal_code": 3461,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Shahri Buzurg",
      "postal_code": 3458,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Shighnan",
      "postal_code": 3467,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Shiki",
      "postal_code": 3464,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Shuhada",
      "postal_code": 3469,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Tagab",
      "postal_code": 3453,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Tashkan",
      "postal_code": 3455,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Wakhan",
      "postal_code": 3475,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Wardooj",
      "postal_code": 3472,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Yaftal",
      "postal_code": 3459,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Yaftal Sefli",
      "postal_code": 3477,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Yamgan",
      "postal_code": 3476,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Yawan",
      "postal_code": 3452,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Badakhshan",
      "district": "Zebak",
      "city": "Zebak",
      "postal_code": 3474,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 34
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Andarab",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Baghlani Jadid",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Burka",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dahana-I-Ghuri",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dih Salah",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Dushi",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Farang Wa Gharu",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Guzargahi Nur",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khinjan",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khost Wa Fereng",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Khwaja Hijran",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Nahrin",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Hisar",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Puli Khumri",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Andarab",
      "postal_code": 3654,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Baghlan-i-Jadeed",
      "postal_code": 3661,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Burka",
      "postal_code": 3664,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Dahana-i-Ghuri",
      "postal_code": 3663,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Deh Salah",
      "postal_code": 3655,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Dushi",
      "postal_code": 3652,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Firing Wa Gharu",
      "postal_code": 3657,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Gozargah-i-Noor",
      "postal_code": 3658,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Khinjan",
      "postal_code": 3653,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Khost Wa Firing",
      "postal_code": 3656,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Khwaja Hejran (Jelga)",
      "postal_code": 3662,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Nahreen",
      "postal_code": 3660,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Pul-i-Hisar",
      "postal_code": 3659,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Pul-i-Khumri GPO",
      "postal_code": 3601,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Pul-i-Khumri North",
      "postal_code": 3602,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Pul-i-Khumri South",
      "postal_code": 3603,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Baghlan",
      "district": "Tala wa Barfak",
      "city": "Tala Wa Barfak",
      "postal_code": 3651,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 36
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Ali Abad",
      "postal_code": 3555,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Chahar Darah",
      "postal_code": 3554,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Gul Tipa",
      "postal_code": 3558,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Haqtash",
      "postal_code": 3559,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Hazrati Imam Sahib",
      "postal_code": 3552,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Kalbad",
      "postal_code": 3557,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Khan Abad",
      "postal_code": 3556,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Kunduz GPO",
      "postal_code": 3501,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Kunduz North",
      "postal_code": 3502,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Kunduz South",
      "postal_code": 3503,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Qala-i-Zal",
      "postal_code": 3553,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Shahrake Bandari Sherkhan",
      "postal_code": 3541,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Ali Abad",
      "city": "Dasht-i-Archi",
      "postal_code": 3551,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Ali Abad",
      "postal_code": 3555,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Chahar Darah",
      "postal_code": 3554,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Gul Tipa",
      "postal_code": 3558,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Haqtash",
      "postal_code": 3559,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Hazrati Imam Sahib",
      "postal_code": 3552,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Kalbad",
      "postal_code": 3557,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Khan Abad",
      "postal_code": 3556,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Kunduz GPO",
      "postal_code": 3501,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Kunduz North",
      "postal_code": 3502,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Kunduz South",
      "postal_code": 3503,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Qala-i-Zal",
      "postal_code": 3553,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Shahrake Bandari Sherkhan",
      "postal_code": 3541,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Archi",
      "city": "Dasht-i-Archi",
      "postal_code": 3551,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Ali Abad",
      "postal_code": 3555,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Chahar Darah",
      "postal_code": 3554,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Gul Tipa",
      "postal_code": 3558,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Haqtash",
      "postal_code": 3559,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Hazrati Imam Sahib",
      "postal_code": 3552,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Kalbad",
      "postal_code": 3557,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Khan Abad",
      "postal_code": 3556,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Kunduz GPO",
      "postal_code": 3501,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Kunduz North",
      "postal_code": 3502,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Kunduz South",
      "postal_code": 3503,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Qala-i-Zal",
      "postal_code": 3553,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Shahrake Bandari Sherkhan",
      "postal_code": 3541,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Chardara",
      "city": "Dasht-i-Archi",
      "postal_code": 3551,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Ali Abad",
      "postal_code": 3555,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Chahar Darah",
      "postal_code": 3554,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Gul Tipa",
      "postal_code": 3558,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Haqtash",
      "postal_code": 3559,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Hazrati Imam Sahib",
      "postal_code": 3552,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Kalbad",
      "postal_code": 3557,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Khan Abad",
      "postal_code": 3556,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Kunduz GPO",
      "postal_code": 3501,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Kunduz North",
      "postal_code": 3502,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Kunduz South",
      "postal_code": 3503,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Qala-i-Zal",
      "postal_code": 3553,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Shahrake Bandari Sherkhan",
      "postal_code": 3541,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Imam Sahib",
      "city": "Dasht-i-Archi",
      "postal_code": 3551,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Ali Abad",
      "postal_code": 3555,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Chahar Darah",
      "postal_code": 3554,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Gul Tipa",
      "postal_code": 3558,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Haqtash",
      "postal_code": 3559,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Hazrati Imam Sahib",
      "postal_code": 3552,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Kalbad",
      "postal_code": 3557,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Khan Abad",
      "postal_code": 3556,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Kunduz GPO",
      "postal_code": 3501,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Kunduz North",
      "postal_code": 3502,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Kunduz South",
      "postal_code": 3503,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Qala-i-Zal",
      "postal_code": 3553,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Shahrake Bandari Sherkhan",
      "postal_code": 3541,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Khan Abad",
      "city": "Dasht-i-Archi",
      "postal_code": 3551,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Ali Abad",
      "postal_code": 3555,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Chahar Darah",
      "postal_code": 3554,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Gul Tipa",
      "postal_code": 3558,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Haqtash",
      "postal_code": 3559,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Hazrati Imam Sahib",
      "postal_code": 3552,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Kalbad",
      "postal_code": 3557,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Khan Abad",
      "postal_code": 3556,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Kunduz GPO",
      "postal_code": 3501,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Kunduz North",
      "postal_code": 3502,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Kunduz South",
      "postal_code": 3503,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Qala-i-Zal",
      "postal_code": 3553,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Shahrake Bandari Sherkhan",
      "postal_code": 3541,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Kunduz",
      "city": "Dasht-i-Archi",
      "postal_code": 3551,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Ali Abad",
      "postal_code": 3555,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Chahar Darah",
      "postal_code": 3554,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Gul Tipa",
      "postal_code": 3558,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Haqtash",
      "postal_code": 3559,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Hazrati Imam Sahib",
      "postal_code": 3552,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Kalbad",
      "postal_code": 3557,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Khan Abad",
      "postal_code": 3556,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Kunduz GPO",
      "postal_code": 3501,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Kunduz North",
      "postal_code": 3502,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Kunduz South",
      "postal_code": 3503,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Qala-i-Zal",
      "postal_code": 3553,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Shahrake Bandari Sherkhan",
      "postal_code": 3541,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Kunduz",
      "district": "Qalay-I-Zal",
      "city": "Dasht-i-Archi",
      "postal_code": 3551,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 35
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Baharak",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Bangi",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chah Ab",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Chal",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Darqad",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Dashti Qala",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Farkhar",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Hazar Sumuch",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Ishkamish",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Kalafgan",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Bahauddin",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Khwaja Ghar",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Namak Ab",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Rustaq",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Taluqan",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Warsaj",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Baharak",
      "postal_code": 3762,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Bangi",
      "postal_code": 3756,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Chahab",
      "postal_code": 3755,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Chal",
      "postal_code": 3763,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Darqad",
      "postal_code": 3758,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Dashti Qala",
      "postal_code": 3759,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Eshkamesh",
      "postal_code": 3765,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Farkhar",
      "postal_code": 3752,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Hazar Sumuch",
      "postal_code": 3761,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Kalafgan",
      "postal_code": 3753,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Khawaja Ghar",
      "postal_code": 3760,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Khwaja Bahawuddin",
      "postal_code": 3757,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Namak Ab",
      "postal_code": 3764,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Rustaq",
      "postal_code": 3754,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Taluqan GPO",
      "postal_code": 3701,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Taluqan North",
      "postal_code": 3702,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Taluqan South",
      "postal_code": 3703,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Warsaj",
      "postal_code": 3751,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Kunduz",
      "province": "Takhar",
      "district": "Yangi Qala",
      "city": "Yangi Qala",
      "postal_code": 3766,
      "region_abbr": "KNDZ",
      "region_no": "RGN 009",
      "region_code": "KNDZ - RGN 009",
      "provincial_code": 37
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Almar",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Andkhoy",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Bilchiragh",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Dawlat Abad",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Gurziwan",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khani Char Bagh",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Khwaja Sabz Posh",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Kohistan",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Maymana",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Pashtun Kot",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaramqol",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qaysar",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Qurghan",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Almar",
      "postal_code": 1862,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Andkhoy",
      "postal_code": 1852,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Bilchiragh",
      "postal_code": 1860,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Dawlat Abad",
      "postal_code": 1855,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Garziwan",
      "postal_code": 1861,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Khan-i-Char Bagh",
      "postal_code": 1851,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Khwaja Sabz Posh-i-Wali",
      "postal_code": 1858,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Kohistan",
      "postal_code": 1857,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Maimana GPO",
      "postal_code": 1801,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Maimana North",
      "postal_code": 1802,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Maimana South",
      "postal_code": 1803,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Pashtun Kot",
      "postal_code": 1859,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Qaisar",
      "postal_code": 1863,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Qaram Qul",
      "postal_code": 1854,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "Qurghan",
      "postal_code": 1853,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Maymana",
      "province": "Faryab",
      "district": "Shirin Tagab",
      "city": "ShirinTagab",
      "postal_code": 1856,
      "region_abbr": "FRB",
      "region_no": "RGN 002",
      "region_code": "FRB - RGN 002",
      "provincial_code": 18
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Balkh",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charbolak",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Charkint",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Chimtal",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dawlatabad",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Dihdadi",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kaldar",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Khulm",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Kishindih",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Marmul",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Nahri Shahi",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Sholgara",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Shortepa",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Balkh",
      "postal_code": 1751,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Char Bolak",
      "postal_code": 1761,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Char kent",
      "postal_code": 1758,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Chimtal",
      "postal_code": 1760,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Dawlat Abad",
      "postal_code": 1752,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Dehdadi",
      "postal_code": 1759,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Kaldar",
      "postal_code": 1755,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Khulm",
      "postal_code": 1756,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Kishindeh",
      "postal_code": 1763,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Marmul",
      "postal_code": 1757,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Mazar-i-Sharif Air Port PO",
      "postal_code": 1742,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Mazar-i-Sharif GPO",
      "postal_code": 1701,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Mazar-i-Sharif North",
      "postal_code": 1702,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Mazar-i-Sharif South",
      "postal_code": 1703,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Mazar-i-Sharif West",
      "postal_code": 1704,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Nahri Shahi",
      "postal_code": 1754,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Shahrak bandry hairatan",
      "postal_code": 1741,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Sholgara",
      "postal_code": 1762,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Shortepa",
      "postal_code": 1753,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Balkh",
      "district": "Zari",
      "city": "Zari",
      "postal_code": 1764,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 17
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "Aybak GPO",
      "postal_code": 2001,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "Aybak North",
      "postal_code": 2002,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "Aybak South",
      "postal_code": 2003,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "City Post Office",
      "postal_code": 2004,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "Dara-i-Soof-i-Bala",
      "postal_code": 2052,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "Dara-i-Soof-i-Payan",
      "postal_code": 2053,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "Feroz Nakhcheer",
      "postal_code": 2054,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "Hazrat-i-Sultan",
      "postal_code": 2055,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "Khuram Wa Sarbagh",
      "postal_code": 2056,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Aybak",
      "city": "Rui-Do-Ab",
      "postal_code": 2051,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "Aybak GPO",
      "postal_code": 2001,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "Aybak North",
      "postal_code": 2002,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "Aybak South",
      "postal_code": 2003,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "City Post Office",
      "postal_code": 2004,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "Dara-i-Soof-i-Bala",
      "postal_code": 2052,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "Dara-i-Soof-i-Payan",
      "postal_code": 2053,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "Feroz Nakhcheer",
      "postal_code": 2054,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "Hazrat-i-Sultan",
      "postal_code": 2055,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "Khuram Wa Sarbagh",
      "postal_code": 2056,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Balla",
      "city": "Rui-Do-Ab",
      "postal_code": 2051,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "Aybak GPO",
      "postal_code": 2001,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "Aybak North",
      "postal_code": 2002,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "Aybak South",
      "postal_code": 2003,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "City Post Office",
      "postal_code": 2004,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "Dara-i-Soof-i-Bala",
      "postal_code": 2052,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "Dara-i-Soof-i-Payan",
      "postal_code": 2053,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "Feroz Nakhcheer",
      "postal_code": 2054,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "Hazrat-i-Sultan",
      "postal_code": 2055,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "Khuram Wa Sarbagh",
      "postal_code": 2056,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Darah Sof Payan",
      "city": "Rui-Do-Ab",
      "postal_code": 2051,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "Aybak GPO",
      "postal_code": 2001,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "Aybak North",
      "postal_code": 2002,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "Aybak South",
      "postal_code": 2003,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "City Post Office",
      "postal_code": 2004,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "Dara-i-Soof-i-Bala",
      "postal_code": 2052,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "Dara-i-Soof-i-Payan",
      "postal_code": 2053,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "Feroz Nakhcheer",
      "postal_code": 2054,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "Hazrat-i-Sultan",
      "postal_code": 2055,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "Khuram Wa Sarbagh",
      "postal_code": 2056,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Feroz Nakhchir",
      "city": "Rui-Do-Ab",
      "postal_code": 2051,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "Aybak GPO",
      "postal_code": 2001,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "Aybak North",
      "postal_code": 2002,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "Aybak South",
      "postal_code": 2003,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "City Post Office",
      "postal_code": 2004,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "Dara-i-Soof-i-Bala",
      "postal_code": 2052,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "Dara-i-Soof-i-Payan",
      "postal_code": 2053,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "Feroz Nakhcheer",
      "postal_code": 2054,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "Hazrat-i-Sultan",
      "postal_code": 2055,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "Khuram Wa Sarbagh",
      "postal_code": 2056,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Hazrat Sultan",
      "city": "Rui-Do-Ab",
      "postal_code": 2051,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "Aybak GPO",
      "postal_code": 2001,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "Aybak North",
      "postal_code": 2002,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "Aybak South",
      "postal_code": 2003,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "City Post Office",
      "postal_code": 2004,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "Dara-i-Soof-i-Bala",
      "postal_code": 2052,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "Dara-i-Soof-i-Payan",
      "postal_code": 2053,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "Feroz Nakhcheer",
      "postal_code": 2054,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "Hazrat-i-Sultan",
      "postal_code": 2055,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "Khuram Wa Sarbagh",
      "postal_code": 2056,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Khuram Wa Sarbagh",
      "city": "Rui-Do-Ab",
      "postal_code": 2051,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "Aybak GPO",
      "postal_code": 2001,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "Aybak North",
      "postal_code": 2002,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "Aybak South",
      "postal_code": 2003,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "City Post Office",
      "postal_code": 2004,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "Dara-i-Soof-i-Bala",
      "postal_code": 2052,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "Dara-i-Soof-i-Payan",
      "postal_code": 2053,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "Feroz Nakhcheer",
      "postal_code": 2054,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "Hazrat-i-Sultan",
      "postal_code": 2055,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "Khuram Wa Sarbagh",
      "postal_code": 2056,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Mazar",
      "province": "Samangan",
      "district": "Ruyi Du Ab",
      "city": "Rui-Do-Ab",
      "postal_code": 2051,
      "region_abbr": "MZR",
      "region_no": "RGN 0010",
      "region_code": "MZR - RGN 0010",
      "provincial_code": 20
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alingar",
      "city": "Ali Negar",
      "postal_code": 2752,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alingar",
      "city": "Ali Shing",
      "postal_code": 2753,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alingar",
      "city": "Badpish",
      "postal_code": 2755,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alingar",
      "city": "Dawlat shah",
      "postal_code": 2754,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alingar",
      "city": "Mehterlam GPO",
      "postal_code": 2701,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alingar",
      "city": "Mehterlam North",
      "postal_code": 2702,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alingar",
      "city": "Mehterlam South",
      "postal_code": 2703,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alingar",
      "city": "Qarghayee",
      "postal_code": 2751,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alingar",
      "city": "Shahrak Sorkhakan Post Office",
      "postal_code": 2704,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alishing",
      "city": "Ali Negar",
      "postal_code": 2752,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alishing",
      "city": "Ali Shing",
      "postal_code": 2753,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alishing",
      "city": "Badpish",
      "postal_code": 2755,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alishing",
      "city": "Dawlat shah",
      "postal_code": 2754,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alishing",
      "city": "Mehterlam GPO",
      "postal_code": 2701,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alishing",
      "city": "Mehterlam North",
      "postal_code": 2702,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alishing",
      "city": "Mehterlam South",
      "postal_code": 2703,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alishing",
      "city": "Qarghayee",
      "postal_code": 2751,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Alishing",
      "city": "Shahrak Sorkhakan Post Office",
      "postal_code": 2704,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Dawlat Shah",
      "city": "Ali Negar",
      "postal_code": 2752,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Dawlat Shah",
      "city": "Ali Shing",
      "postal_code": 2753,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Dawlat Shah",
      "city": "Badpish",
      "postal_code": 2755,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Dawlat Shah",
      "city": "Dawlat shah",
      "postal_code": 2754,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Dawlat Shah",
      "city": "Mehterlam GPO",
      "postal_code": 2701,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Dawlat Shah",
      "city": "Mehterlam North",
      "postal_code": 2702,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Dawlat Shah",
      "city": "Mehterlam South",
      "postal_code": 2703,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Dawlat Shah",
      "city": "Qarghayee",
      "postal_code": 2751,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Dawlat Shah",
      "city": "Shahrak Sorkhakan Post Office",
      "postal_code": 2704,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Mihtarlam",
      "city": "Ali Negar",
      "postal_code": 2752,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Mihtarlam",
      "city": "Ali Shing",
      "postal_code": 2753,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Mihtarlam",
      "city": "Badpish",
      "postal_code": 2755,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Mihtarlam",
      "city": "Dawlat shah",
      "postal_code": 2754,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Mihtarlam",
      "city": "Mehterlam GPO",
      "postal_code": 2701,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Mihtarlam",
      "city": "Mehterlam North",
      "postal_code": 2702,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Mihtarlam",
      "city": "Mehterlam South",
      "postal_code": 2703,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Mihtarlam",
      "city": "Qarghayee",
      "postal_code": 2751,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Mihtarlam",
      "city": "Shahrak Sorkhakan Post Office",
      "postal_code": 2704,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Qarghayi",
      "city": "Ali Negar",
      "postal_code": 2752,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Qarghayi",
      "city": "Ali Shing",
      "postal_code": 2753,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Qarghayi",
      "city": "Badpish",
      "postal_code": 2755,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Qarghayi",
      "city": "Dawlat shah",
      "postal_code": 2754,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Qarghayi",
      "city": "Mehterlam GPO",
      "postal_code": 2701,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Qarghayi",
      "city": "Mehterlam North",
      "postal_code": 2702,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Qarghayi",
      "city": "Mehterlam South",
      "postal_code": 2703,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Qarghayi",
      "city": "Qarghayee",
      "postal_code": 2751,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Laghman",
      "district": "Qarghayi",
      "city": "Shahrak Sorkhakan Post Office",
      "postal_code": 2704,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 27
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Achin",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bati Kot",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Bihsud",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Chaparhar",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Darai Nur",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Dur Baba",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Goshta",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Haska Meyna/Deh Bala",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Hisarak",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Jalalabad",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kama",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Khogyani",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kot",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Kuz Kunar",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Lal Pur",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Momand Dara",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Nazyan",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Pachir Aw Agam",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Rodat",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Sherzad",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Shinwar",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Achin",
      "postal_code": 2663,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "AirPort Post Office",
      "postal_code": 2642,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Bandar-e-Torkham",
      "postal_code": 2641,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Bati Kot",
      "postal_code": 2667,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Behsud",
      "postal_code": 2657,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Chapar Har",
      "postal_code": 2655,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Dah Bala",
      "postal_code": 2662,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Darah-i-Noor",
      "postal_code": 2659,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Dur Baba",
      "postal_code": 2666,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Goshta",
      "postal_code": 2671,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Hesarak",
      "postal_code": 2651,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Jalalabad GPO",
      "postal_code": 2601,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Jalalabad North",
      "postal_code": 2602,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Jalalabad South",
      "postal_code": 2603,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Kama",
      "postal_code": 2660,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Khugyani",
      "postal_code": 2653,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "kot",
      "postal_code": 2664,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Kuzkunar",
      "postal_code": 2658,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Lalpoor",
      "postal_code": 2670,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Muhmand Dara",
      "postal_code": 2668,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Nazyan",
      "postal_code": 2665,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Pachir Waagam",
      "postal_code": 2654,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Rodat",
      "postal_code": 2661,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Sherzad",
      "postal_code": 2652,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Shinwar",
      "postal_code": 2669,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Spin ghar",
      "postal_code": 2672,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Nangarhar",
      "province": "Nangarhar",
      "district": "Surkh Rod",
      "city": "Surkh Rud",
      "postal_code": 2656,
      "region_abbr": "NGR",
      "region_no": "RGN 0011",
      "region_code": "NGR - RGN 0011",
      "provincial_code": 26
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Alasay",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Alasay",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Alasay",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Alasay",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Alasay",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Alasay",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Alasay",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Alasay",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Alasay",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Bak",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Bak",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Bak",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Bak",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Bak",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Bak",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Bak",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Bak",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Bak",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Gurbuz",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Gurbuz",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Gurbuz",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Gurbuz",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Gurbuz",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Gurbuz",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Gurbuz",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Gurbuz",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Gurbuz",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Awal Kohistan",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Awal Kohistan",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Awal Kohistan",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Awal Kohistan",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Awal Kohistan",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Awal Kohistan",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Awal Kohistan",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Awal Kohistan",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Awal Kohistan",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Duwum Kohistan",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Duwum Kohistan",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Duwum Kohistan",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Duwum Kohistan",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Duwum Kohistan",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Duwum Kohistan",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Duwum Kohistan",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Duwum Kohistan",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Hesa Duwum Kohistan",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Jaji Maydan",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Jaji Maydan",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Jaji Maydan",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Jaji Maydan",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Jaji Maydan",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Jaji Maydan",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Jaji Maydan",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Jaji Maydan",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Jaji Maydan",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Koh Band",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Koh Band",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Koh Band",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Koh Band",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Koh Band",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Koh Band",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Koh Band",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Koh Band",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Koh Band",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Mahmud Raqi",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Mahmud Raqi",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Mahmud Raqi",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Mahmud Raqi",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Mahmud Raqi",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Mahmud Raqi",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Mahmud Raqi",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Mahmud Raqi",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Mahmud Raqi",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Nijrab",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Nijrab",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Nijrab",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Nijrab",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Nijrab",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Nijrab",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Nijrab",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Nijrab",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Nijrab",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Tagab",
      "city": "Alasai",
      "postal_code": 1252,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Tagab",
      "city": "Al bironi University",
      "postal_code": 1202,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Tagab",
      "city": "Hissa-i-Awali Kohistan",
      "postal_code": 1254,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Tagab",
      "city": "Hissa-i-Duwumi Kohistan",
      "postal_code": 1253,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Tagab",
      "city": "Koh Band",
      "postal_code": 1251,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Tagab",
      "city": "Mahmood Raqi GPO",
      "postal_code": 1201,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Tagab",
      "city": "Nijrab",
      "postal_code": 1255,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Tagab",
      "city": "Pul-e-Syad",
      "postal_code": 1203,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Kapisa",
      "district": "Tagab",
      "city": "Tagab",
      "postal_code": 1256,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 12
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Bagram",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Charikar",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Ghorband",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Jabal Saraj",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Kohi Safi",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Salang",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sayed Khel",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Sheikh Ali",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Shinwari",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Bagram",
      "postal_code": 1157,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Charikar GPO",
      "postal_code": 1101,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Charikar North",
      "postal_code": 1102,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Charikar South",
      "postal_code": 1103,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Ghurband",
      "postal_code": 1153,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Jabulussaraj",
      "postal_code": 1156,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Koh-i-Safi",
      "postal_code": 1159,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Salang",
      "postal_code": 1155,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Sayyid Khel",
      "postal_code": 1158,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Sheykh Ali",
      "postal_code": 1151,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Shinwari",
      "postal_code": 1154,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    },
    {
      "region_name": "Parwan",
      "province": "Parwan",
      "district": "Surkhi Parsa",
      "city": "Surkhi Parsa",
      "postal_code": 1152,
      "region_abbr": "PRWN",
      "region_no": "RGN 0012",
      "region_code": "PRWN - RGN 0012",
      "provincial_code": 11
    }
  ]